import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import BarcodeTable from '../AppGrid/BarcodeTable';
import { EndoSetup } from '../AppGrid/EndoSetup';
import NoRoutes from '../components/common/NoRoutesAccess';
import ExternalLayout from '../components/layouts/External';
import InternalLayout from '../components/layouts/Internal';
import MainLayout from '../components/layouts/Main';
import IncubatorCycleDetailForm from '../views/IncubatorCycleDetail';
import ItemSync from '../views/ItemSync';
import { QuickSearchScope } from '../views/QuickSearchScope';
import { Region } from '../views/Regions';
import { ScopeRegionConfiguration } from '../views/ScopeRegionConfiguration';
import UserSync from '../views/UserSync';
import AssetsList from '../views/grids/AssetsList';
import DashboardCycleList from '../views/grids/DashboardCycleList';
import DashboardIncubatorList from '../views/grids/DashboardIncubatorList';
import DashboardTaskList from '../views/grids/DashboardTaskList';
import EndoSetupSopes from '../views/grids/EndoSetupScope';
import LogsList from '../views/grids/LogsList';
import EndoSetupUser from '../views/EndoSetupUser';
import EndoSetupPhysician from '../views/EndoSetupPhysician';
import InterfaceLogs from '../views/InterfaceLogs';
import NonMedivator from '../views/NonMedivator';
import TrackCycleTable from '../views/TrackCycle';
import EnspireCycleInfo from '../views/EnspireCycleInfo';
import EndoProfile from '../views/EndoProfile';
import AppConfig from '../views/AppConfig'
import ModalityDashboard from '../views/ModalityDashboard';
import ForgotPassword from '../views/ForgotPassword';
import InterfaceConfig from '../views/InterfaceConfig';
import Report from '../views/Report';
import UserList from '../AppGrid/UserTable';
import RoleList from '../AppGrid/RoleTable';
import AssetCodeList from '../views/grids/AssetCodeList';
import TagIdList from '../AppGrid/TagIdTable';
import HospitalList from '../AppGrid/HospitalTable';
import Items from '../views/grids/Items';
import Transaction from '../views/grids/TransactionList';
import UserTypeList from '../AppGrid/UserTypeTable';
import TopicPermission from '../AppGrid/TopicPermissionTable';
import AuthorizedClient from '../AppGrid/AuthorizedClientTable';
import ClientRequests from '../AppGrid/ClientRequestsTable';
import EndoScopeTransactionList from '../views/grids/EndoScopeTransactionList';
import CycleList from '../views/grids/CycleList';
import EndoScopeList from '../AppGrid/EndoScopeTable';
import LanguageList from '../views/grids/LanguageList';
import LanguageMapperList from '../AppGrid/LanguageMapperTable';
import IncubatorCycleList from '../views/grids/IncubatorCycleList';
import HolidayList from '../AppGrid/HolidayTable';
import ReusableTestPackList from '../AppGrid/ReusableTestPackTable';
import RoleModuleList from '../views/grids/RoleModuleList';
import CycleAttachmentList from '../views/grids/CycleAttachmentList';
import TaskTypeList from '../AppGrid/TaskTypeTable';
import TaskList from '../AppGrid/TaskTable';
import TaskAssignmentList from '../AppGrid/TaskAssignmentTable';
import IndicatorList from '../AppGrid/IndicatorTable';
import LotDetailList from '../AppGrid/LotDetailTable';
import ModelList from '../AppGrid/ModelTable';
import CycleActionStatusList from '../AppGrid/CycleActionStatusTable';
import LocationList from '../AppGrid/LocationTable';
import EquipmentList from '../AppGrid/EquipmentTable';
import ClientList from '../views/grids/ClientList';
import EquipmentTypeList from '../AppGrid/EquipmentTypeTable';
import EquipmentAttachments from '../views/EquipmentAttachments';
import AccessLogDetailList from '../AppGrid/AccessLogDetailTable';
import PrintConfig from '../views/PrintConfig';
import Login from '../views/Login';
import EquipmentInfo from '../views/EquipmentInfo';
import CycleInfo from '../views/CycleInfo';
import SterlizerCycleInfo from '../views/SterilizerCycleInfo';
import UserInfo from '../views/UserInfo';
import VideoList from '../components/common/VideoList';
import Endosystemcycleinfo from '../views/EndoSystemCycleInfo';
import AdvantageCycleInfo from '../views/AdvantageCycleInfo';
import DashboardView from '../views/Dashboard';
import CommandForm from '../views/forms/CommandForm';
import ForbiddenPage from '../views/ForbiddenPage';
import HookupSync from '../views/HookupSync';
import UserPasswordForm from '../views/forms/UserPasswordForm';

const routes = [
	{ name: 'Dashboard', path: 'dashboard', component: <DashboardView />, permissions: ["Dashboard"] },
	{ name: 'DashboardTasks', path: 'dashboardtasks', component: <DashboardTaskList />, permissions: ["Dashboard"] },
	{ name: 'viewAttachments', path: 'viewAttachments', component: <EquipmentAttachments />, permissions: ["EquipmentAttachment"] },
	{ name: 'DashboardCycles', path: 'dashboardcycles', component: <DashboardCycleList />, permissions: ["Dashboard"] },
	{ name: 'DashboardIncubator', path: 'dashboardincubator', component: <DashboardIncubatorList />, permissions: ["Dashboard", "Cycle"] },
	{ name: 'ModalityDashboard', path: 'modalitydashboard', component: <ModalityDashboard />, permissions: ["Dashboard", "Cycle"] },
	{ name: 'IncubatorCycleList', path: 'incubatorcyclelist', component: <IncubatorCycleList />, permissions: ["Cycle"] },
	{ name: 'Incubator Cycle Detail Form', path: 'incubatorcycledetailform', component: <IncubatorCycleDetailForm />, permissions: ["IncubatorCycleDetail"] },
	{ name: 'User', path: 'userlist', component: <UserList />, permissions: ["User"] },
	{ name: 'AppConfig', path: 'appconfig', component: <AppConfig />, permissions: ["AppConfig"] },
	{ name: 'Report', path: 'report', component: <Report />, permissions: ["Report"] },
	{ name: 'CycleList', path: 'cyclelist', component: <CycleList />, permissions: ["Dashboard", "Cycle"] },
	{ name: 'Location', path: 'locationlist', component: <LocationList />, permissions: ["Location"] },
	{ name: 'EquipmentTypeList', path: 'equipmenttypelist', component: <EquipmentTypeList />, permissions: ["Dashboard", "EquipmentType"] },
	{ name: 'Equipment', path: 'equipmentlist', subPath: [':modalityId'], component: <EquipmentList />, permissions: ["Equipment"] },
	{ name: 'AccessLogDetail', path: 'accesslogdetaillist', component: <AccessLogDetailList />, permissions: ["AccessLog"] },
	{ name: 'EquipmentInfo', path: 'equipmentinfo', component: <EquipmentInfo />, permissions: ["Dashboard"] },
	{ name: 'Cycle Info', path: 'cycleinfo', component: <CycleInfo />, permissions: ["Cycle"] },
	{ name: 'SterilizerCycleInfo', path: 'sterilizercycleinfo', component: <SterlizerCycleInfo />, permissions: ["Cycle"] },
	{ name: 'Client', path: 'clientlist', component: <ClientList />, permissions: ["Clients"] },
	{ name: 'CycleActionStatus', path: 'cycleactionstatuslist', component: <CycleActionStatusList /> },
	{ name: 'EquipmentModel', path: 'modellist', component: <ModelList />, permissions: ["Model"] },
	{ name: 'IndicatorModel', path: 'indicatorlist', component: <IndicatorList />, permissions: ["Indicator"] },
	{ name: 'IndicatorLotDetail', path: 'lotdetaillist', component: <LotDetailList />, permissions: ["LotDetail"] },
	{ name: 'TaskAssignment', path: 'taskassignmentlist', component: <TaskAssignmentList />, permissions: ["TaskAssignment"] },
	{ name: 'Tasks', path: 'tasklist', component: <TaskList />, permissions: ["Tasks"] },
	{ name: 'TaskType', path: 'tasktypelist', component: <TaskTypeList />, permissions: ["Task"] },
	{ name: 'Cycle Attachment', path: 'cycleattachmentlist', component: <CycleAttachmentList />, permissions: ["Cycle"] },
	{ name: 'RoleModule', path: 'rolelist', component: <RoleList />, permissions: ["RoleModule"] },
	{ name: 'Role Module', path: 'rolemodulelist', component: <RoleModuleList />, permissions: ["RoleModule"] },
	{ name: 'ReusableTestPack', path: 'reusabletestpacklist', component: <ReusableTestPackList />, permissions: ["ReusableTestPack"] },
	{ name: 'Holidays', path: 'holidaylist', component: <HolidayList />, permissions: ["Holiday"] },
	{ name: 'UserInfo', path: 'userinfo', component: <UserInfo />, permissions: ["UserProfile"] },
	{ name: 'VideoList', path: 'VideoList', component: <VideoList /> },
	{ name: 'PrintConfig', path: 'printconfig', component: <PrintConfig />, permissions: ["PrintConfig"] },
	{ name: 'Enod System Cycle', path: 'endosystemcycleinfo', component: <Endosystemcycleinfo />, permissions: ["Cycle"] },
	{ name: 'LanguageMapper', path: 'languagemapperlist', component: <LanguageMapperList />, permissions: ["LanguageMapper"] },
	{ name: 'Language', path: 'languagelist', component: <LanguageList />, permissions: ["LanguageMapper"] },
	{ name: 'EndoScope', path: 'endoscopelist', component: <EndoScopeList />, permissions: ["EndoScope"] },
	{ name: 'UserType', path: 'usertypelist', component: <UserTypeList />, permissions: ["UserType"] },
	{ name: 'EndoScopeDetail', path: 'transactionlist', component: <EndoScopeTransactionList />, permissions: ["EndoScope"] },
	{ name: 'Cabinet Cycle', path: 'advantagecycleinfo', component: <AdvantageCycleInfo />, permissions: ["Cycle"] },
	{ name: 'ClientRequests', path: 'clientrequests', component: <ClientRequests />, permissions: ["ClientRequests"] },
	{ name: 'AuthorizedClients', path: 'authorizedclients', component: <AuthorizedClient />, permissions: ["Broker", "AuthorizedClients"] },
	{ name: 'TopicPermission', path: 'topicpermission', component: <TopicPermission />, permissions: ["TopicPermission"] },
	{ name: 'Logs', path: 'logs', component: <LogsList />, permissions: ["Logs"] },
	{ name: 'Transaction', path: 'transaction', component: <Transaction />, permissions: ["Transaction"] },
	{ name: 'Items', path: 'items', component: <Items />, permissions: ["Items"] },
	{ name: 'Client', path: 'client', component: <HospitalList />, permissions: ["Clients"] },
	{ name: 'Command Form', path: 'command', component: <CommandForm />, permissions: ["Broker", "AuthorizedClients"] },
	{ name: 'Assets', path: 'asset', component: <AssetsList />, permissions: ["Assets"] },
	{ name: 'MonitoringByTag', path: 'antenna', component: <TagIdList />, permissions: ["MonitoringByTag"] },
	{ name: 'AssetsCode', path: 'assetscode', component: <AssetCodeList />, permissions: ["Assets"] },
	{ name: "Endo Setup", path: "endoSetup", component: <EndoSetup />, permissions: ["EndoSetup"] },
	{ name: "Endo Setup Scope", path: "endoScope-scope", component: <EndoSetupSopes />, permissions: ["EndoSetup"] },
	{ name: "User Sync", path: "usersync", component: <UserSync />, permissions: ["Cycle"] },
	{ name: "Item Sync", path: "itemsync", component: <ItemSync />, permissions: ["ItemSync", "HuluScope"] },
	{ name: "Non Medivator", path: "nonmedivator", component: <NonMedivator />, permissions: [] },
	{ name: "Quick Search Scope", path: "quicksearchscope", component: <QuickSearchScope />, permissions: ["HuluScope"] },
	{ name: 'Barcode', path: 'barcode', component: <BarcodeTable />, permissions: ["EndoScope"] },
	{ name: 'Interface Config', path: 'interfaceConfig', component: <InterfaceConfig />, permissions: ["InterfaceConfiguration"] },
	{ name: 'Scope Regions', path: 'scopeRegion', component: <ScopeRegionConfiguration />, permissions: ["ScopeRegion"] },
	{ name: 'CycleList', path: 'endoCycleslist', component: <CycleList />, permissions: ["EndoCycles"] },
	{ name: 'Regions', path: 'region', component: <Region />, permissions: ["ScopeRegion"] },
	{ name: "Endo Setup User", path: "endoSetupUser", component: <EndoSetupUser />, permissions: ["EndoSetupUser"] },
	{ name: "No Dashboard", path: "/", component: <NoRoutes />, permissions: [] },
	{ name: "Endo Setup Physician", path: "endoSetupPhysician", component: <EndoSetupPhysician />, permissions: ["EndoSetupPhysician"] },
	{ name: "Interface Log", path: "interfaceLogs", component: <InterfaceLogs />, permissions: ["InterfaceLog"] },
	{ name: "Track Cycle", path: "trackcycle", component: <TrackCycleTable />, permissions: ["Trackcycle"] },
	{ name: "Enspire3000", path: "enspirecycleinfo", component: <EnspireCycleInfo />, permissions: ["Cycle"] },
	{ name: "Endo Profile", path: "endoprofile", component: <EndoProfile />, permissions: ["InterfaceConfiguration"] },
	{ name: "Forbidden Page", path: "forbiddenpage", component: <ForbiddenPage /> },
	{ name: "HookupSync", path: "hookupsync", component: <HookupSync />, permissions: ["ItemSync", "HuluScope"] },
	{ name: 'UserPasswordForm', path: 'userpasswordform', component: <UserPasswordForm />, permissions: ["User"] },

];

const ProtectedRoutes = ({ children, permissions = [] }) => {
	const { loggedin, modules } = useSelector((state) => state?.auth || {});
	if (!loggedin) return null;
	// If no valid permissions specified, allow access
	const hasValidPermissions = Array.isArray(permissions) && permissions.some(p => p?.trim());
	if (hasValidPermissions) {
		const isAuthorized = permissions.some(
			(permission) => modules?.[permission]?.Module
		);

		if (!isAuthorized) return <Navigate to="/forbiddenpage" replace />;
	}

	return <InternalLayout>{children}</InternalLayout>;
};

export default function NavRouter() {
	return (
		<Routes>
			<Route element={<MainLayout />}>
				{routes.map((route) => (
					<Route
						key={`route-${route.name}`}
						path={`/${route.path}`}
						element={
							<ProtectedRoutes permissions={route.permissions}>
								{route.component}
							</ProtectedRoutes>
						}
					/>
				))}
				<Route path="/login" element={<ExternalLayout><Login />	</ExternalLayout>} />
				<Route path="/setup" element={<ExternalLayout><AppConfig isPublic /></ExternalLayout>} />
				<Route path="/forgotpassword" element={<ExternalLayout><ForgotPassword /></ExternalLayout>} />
				<Route path="*" element={<Navigate to="/login" />} />
			</Route>
		</Routes>
	);
}